import * as React from 'react';

export interface ITransmittalIconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const TransmittalIcon = React.forwardRef<SVGSVGElement, ITransmittalIconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1.0404 0 0 1.0404 -98.016 -47.497)">
          <g fontFamily="sans-serif" fontSize="10.583px" wordSpacing="0px" aria-label="T 1">
            <g
              transform="matrix(.92985 0 0 .86537 6.8704 6.826)"
              fontFamily="sans-serif"
              fontSize="10.583px"
              aria-label="T1"
            >
              <g
                transform="matrix(3.0828,0,0,3.3126,-207.5,-95.579)"
                fontFamily="sans-serif"
                fontSize="8.652px"
                strokeWidth=".0072031"
                aria-label="T1"
              >
                <text x="97.087555" y="47.709003" fontFamily="sans-serif" fontSize="4.6513px" xmlSpace="preserve">
                  <tspan x="97.087555" y="47.709003" strokeWidth=".0072031" />
                </text>
                <g aria-label="T1">
                  <path d="m99.233 43.283q0-0.19967 0.19967-0.19967h1.9967q0.19967 0 0.19967 0.19967t-0.19967 0.19967h-0.79867v3.3943q0 0.19967-0.19967 0.19967t-0.19967-0.19967v-3.3943h-0.79867q-0.19967 0-0.19967-0.19967z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
